export default __webpack_public_path__ + "static/media/winGif.23ed7c73.gif";